import * as R from 'ramda'
import createSelector from 'utils/redux/createSelector' // import { createSelector } from 'reselect'
import { createSearchAction, getSearchSelectors } from 'redux-search'

import { sort } from './common'
import { owners, properties, agents } from './entities'
import { commentsByObjectID } from './index'
import { propertyEventsEx, propertyLLEventsEx } from './events'
import { attachmentsByObjectID } from './attachments'

global.owners = owners
global.agents = agents
global.commentsByObjectID = commentsByObjectID
global.attachmentsByObjectID = attachmentsByObjectID
global.propertyEventsEx = propertyEventsEx

export let propertiesEx = global.propertiesEx = createSelector(
	[properties, owners, agents, commentsByObjectID, attachmentsByObjectID, propertyEventsEx/*, sort('property', {secondary: 'alias'})*/]
  ,	(properties, owners, agents, commentsByObjectID, attachmentsByObjectID, propertyEventsEx/*, sort*/) => {
		let extend = property => {
		 let status = propertyEventsEx[property._id].status
		 let statusForSort = (status.forRent=='For Rent')?'forRent':
       (status.occupied=='Occupied')?
       (status.paid)?'occupied':'occupiedNoPaid':
       (property.dateTill)?'retired':'outOfServ'
			 return ({
			 ...property
			 , ...propertyEventsEx[property._id]
			 , agent: (property.agentID && agents[property.agentID] || {}).firstName || ""
			 , owner: (owners[property.ownerID] || {}).firstName || ""
			 , comments: commentsByObjectID[property._id] || []
			 , attachments: attachmentsByObjectID[property._id] || []
			 , id: property._id
			 , statusForSort
		 })
	 }
		return R.map(extend)(properties)
	}
  // , 'propertiesEx'
)

export let propertiesLLEx = global.propertiesLLEx = createSelector(
	[properties, owners, agents, commentsByObjectID, attachmentsByObjectID, propertyLLEventsEx]
  ,	(properties, owners, agents, commentsByObjectID, attachmentsByObjectID, propertyEventsEx) => {
		let extend = property => {
		 let status = propertyEventsEx[property._id].status
		 let statusForSort = (status.forRent=='For Rent')?'forRent':
       (status.occupied=='Occupied')?
       (status.paid)?'occupied':'occupiedNoPaid':
       (property.dateTill)?'retired':'outOfServ'
			 return ({
			 ...property
			 , ...propertyEventsEx[property._id]
			 , agent: (property.agentID && agents[property.agentID] || {}).firstName || ""
			 , owner: (owners[property.ownerID] || {}).firstName || ""
			 , comments: commentsByObjectID[property._id] || []
			 , attachments: attachmentsByObjectID[property._id] || []
			 , id: property._id
			 , statusForSort
		 })
	 }
		return R.map(extend)(properties)
	}
  // , 'propertiesLLEx'
)



// WEBPACK FOOTER //
// ./src/selectors/properties.js